export default __webpack_public_path__ + "static/media/pink.df45a809.png";